import React from 'react';
import { Button, Modal } from 'antd';
import { List } from 'react-structure-admin';
import { useDispatch } from 'react-redux';
import {
  openRegularizePayment,
  close
} from 'stores/subscriptions/subscriptionActions';
import { Crisp } from 'crisp-sdk-web';

const SubscriptionPendingPayment = () => {
  const dispatch = useDispatch();

  const handleContactClick = () => {
    Crisp.chat.open();
    dispatch(close());
  };

  const handleClose = () => {
    dispatch(close());
  };

  const handleRegularizePayment = () => {
    dispatch(openRegularizePayment());
  };

  const customFooter = () => {
    return (
      <>
        <Button type="default" onClick={handleContactClick}>
          Falar com o suporte
        </Button>
        <Button type="primary" onClick={handleRegularizePayment}>
          Regularizar pagamento
        </Button>
      </>
    );
  };

  return (
    <>
      <Modal
        visible
        title={'Assinatura com pagamento pendente'}
        onCancel={handleClose}
        footer={customFooter()}
      >
        <div>
          <p>
            Para cancelar sua assinatura você deve estar com o pagamento em dia.
            O que deseja fazer?
          </p>
        </div>
      </Modal>
    </>
  );
};

export default List.create(SubscriptionPendingPayment, {
  resource: 'subscription-plans',
  fixedQueryParams: { onlyVisible: true }
});
